import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ba6411c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sqg-login" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"sqg-login__left\" data-v-7ba6411c><div class=\"sqg-login__logo\" data-v-7ba6411c><i class=\"fab fa-fly\" data-v-7ba6411c></i></div><div class=\"sqg-login__title\" data-v-7ba6411c><div class=\"sqg-login__mainTitle\" data-v-7ba6411c>Silae Onboarding Produit</div><div class=\"sqg-login__subTitle\" data-v-7ba6411c>Espace personnel</div></div></div>", 1)
const _hoisted_3 = { class: "sqg-login__right" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-plus logo" }, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Créez votre compte ")
const _hoisted_6 = { class: "sqg-login__form" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Créer mon compte")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-glass-cheers" }, null, -1))
const _hoisted_9 = { class: "sqg-login__errorMsg" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sqg-login__mark" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Erreur lors de la création du compte", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.loader)
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 0,
            msg: "Création du compte en cours ..."
          }))
        : (_openBlock(), _createElementBlock("form", {
            key: 1,
            onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.signup && _ctx.signup(...args)), ["prevent"]))
          }, [
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Input, {
                required: "",
                type: "text",
                placeholder: "Prénom",
                modelValue: _ctx.firstname,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstname) = $event)),
                helperMsg: ['Champ obligatoire'],
                "onUpdate:error": _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateError($event)))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Input, {
                required: "",
                type: "text",
                placeholder: "Nom",
                modelValue: _ctx.lastname,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.lastname) = $event)),
                helperMsg: ['Champ obligatoire'],
                "onUpdate:error": _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateError($event)))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Input, {
                required: "",
                type: "text",
                placeholder: "Entreprise",
                modelValue: _ctx.companyName,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.companyName) = $event)),
                helperMsg: ['Champ obligatoire'],
                "onUpdate:error": _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateError($event)))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Input, {
                required: "",
                type: "text",
                placeholder: "Adresse e-mail",
                modelValue: _ctx.email,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.email) = $event)),
                helperMsg: ['Champ obligatoire'],
                "onUpdate:error": _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateError($event)))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Input, {
                required: "",
                type: "password",
                placeholder: "Mot de passe",
                modelValue: _ctx.password,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.password) = $event)),
                helperMsg: ['Champ obligatoire'],
                "onUpdate:error": _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateError($event)))
              }, null, 8, ["modelValue"])
            ]),
            _createVNode(_component_Button, {
              disabled: !_ctx.canLogin,
              type: "submit"
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                _hoisted_8
              ]),
              _: 1
            }, 8, ["disabled"]),
            _withDirectives(_createElementVNode("div", _hoisted_9, _hoisted_12, 512), [
              [_vShow, _ctx.isError]
            ])
          ], 32))
    ])
  ]))
}